(function () {
  class ImageTextNavigator {
    constructor(container) {
      this.container = container;
      this.sectionId = this.container.dataset.sectionId;
      this.interactionType = this.container.dataset.interactionType;
      this.navItems = this.container.querySelectorAll('.nav-item');
      this.images = this.container.querySelectorAll('.navigator-image');

      this.init();
    }

    init() {
      this.navItems.forEach((item, index) => {
        if (this.interactionType === 'hover') {
          item.addEventListener('mouseenter', () => {
            this.setActiveItem(index);
          });
        } else {
          item.addEventListener('click', () => {
            this.toggleItemContent(index);
          });
        }
      });
    }

    setActiveItem(index) {
      this.navItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      this.images.forEach((image, i) => {
        if (i === index) {
          image.classList.add('active');
        } else {
          image.classList.remove('active');
        }
      });
    }

    toggleItemContent(index) {
      const isActive = this.navItems[index].classList.contains('active');

      if (isActive) {
        return;
      }

      this.setActiveItem(index);
    }
  }

  const navigatorSections = document.querySelectorAll(
    '[data-section-type="image-text-navigator"]',
  );
  navigatorSections.forEach((section) => {
    new ImageTextNavigator(section);
  });
})();
